import '.d{display:flex;}.ssr-plugin'
import '.a5{align-items:center;}.ssr-plugin'
import '.a9{gap:0.5rem;}.ssr-plugin'
import '.cu{height:2.5rem;}.ssr-plugin'
import '.be{justify-content:flex-end;}.ssr-plugin'
import '.bf{position:relative;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ai{cursor:pointer;}.ssr-plugin'
import { MegaMenu } from '../../megaMenu/MegaMenu.desktop'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'
import { NavBarDesktop } from '../blocks/NavBar.desktop'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { useLocation } from 'wouter'
import { authTabs } from '../../authentication/authTabs'

const ACCOUNT_SLOT_WIDTH = '14rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const AuthButtons = () => {
  const { showAuthModal } = useAuthModal()

  return (
    <div className="d a5 a9"
    >
      <Button
        variant="secondary"
        label="Log in"
        onClick={() => showAuthModal(authTabs.login)}
        style={{ whiteSpace: 'nowrap' }}
      />
      <Button
        variant="primary"
        label="Meld je aan"
        onClick={() => showAuthModal(authTabs.signUp)}
        style={{ whiteSpace: 'nowrap' }}
      />
    </div>
  )
}

type AccountSectionProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const AccountSection = ({
  userName,
  avatar,
  isLoading,
}: AccountSectionProps) => {
  const [, navigate] = useLocation()

  if (isLoading) {
    return (
      <div className="cu" style={{ width: ACCOUNT_SLOT_WIDTH,}} />
    )
  }

  return (
    <div className="d be"
      style={{
        width: ACCOUNT_SLOT_WIDTH,
        animation: ACCOUNT_APPEAR_ANIMATION,
      }}
    >
      {userName ? (
        <ProfileMenu>
          <div className="bf d e a5 ai"
          >
            <Avatar
              size="small"
              labelSource={userName}
              image={avatar}
              onClick={() => navigate(pages.dashboard)}
            />
          </div>
        </ProfileMenu>
      ) : (
        <AuthButtons />
      )}
    </div>
  )
}

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

export const TopNavBar = ({ userName, avatar, isLoading }: TopNavBarProps) => {
  const translations = useTranslations().app.nav
  const tenant = useTenantContext()

  return (
    <NavBarDesktop
      logo={<Image src={tenant.logoUrl} alt={`${tenant.title} Logo`} />}
    >
      <HoverTabs.Group>
        <HoverTabs.Tab label={translations.find}>
          <MegaMenu variant={'find'} />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.start}>
          <MegaMenu variant={'start'} />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.learn}>
          <MegaMenu variant={'learn'} />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.aboutUs}>
          <MegaMenu variant={'aboutUs'} />
        </HoverTabs.Tab>
      </HoverTabs.Group>

      <AccountSection
        userName={userName}
        avatar={avatar}
        isLoading={isLoading}
      />
    </NavBarDesktop>
  )
}
